/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var ProjectsIcon = createIcon("ProjectsIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#555';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#projects-a)",
    stroke: _color,
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.045 14.137-3.712.53.53-3.712 9.546-9.546a2.25 2.25 0 013.182 3.182l-9.546 9.546Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.25 8.25v13.5a1.5 1.5 0 01-1.5 1.5H2.25a1.5 1.5 0 01-1.5-1.5V5.25a1.5 1.5 0 011.5-1.5h10.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 6.75H3.75v13.5h16.5v-9m-16.5 0h3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 17.25h4.5v3m7.5-3h4.5m-3-3h3"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "projects-a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24",
    fill: "#fff"
  }))));
}, {
  "replaceColor": true
});